import styled from 'styled-components';
import { media } from 'style-utils';

export const SearchResultContainer = styled.div`
  color: ${props => props.theme.color.base2};
  ${media.mobileTablet`
    width: 100vw;
    height: 80%;
    overflow: scroll;
  `}
`;

export const GoBackContainer = styled.div`
  background-color: ${props => props.theme.color.white};
  border: solid 1px ${props => props.theme.color.iceBlue};

  width: 100vw;
  position: fixed;
  ${media.desktop`
    z-index: 1;
     padding: 16px;
  `}
  ${media.mobileTablet`
    padding: 14px 16px;
    height: 44px;
    position: static;
    & span {
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
    }

  `}
`;
export const EntryCountContainer = styled.div`
  background-color: ${props => props.theme.color.white};
  border: solid 1px ${props => props.theme.color.iceBlue};
  padding: 0;
  width: 100vw;
  position: static;
  top: 96px;
`;

export const Container = styled.div`
  top: 56px;
  position: relative;
  padding: 0 28px;
  max-width: 100%;
  min-width: 1120px;
  margin: 16px auto;
  width: ${props => props.wide && '80%'};

  ${media.mobileTablet`
    position: static;
    margin: 0;
    padding: 0;
    & > div {
      padding 0;
      width: 100vw;
      overflow: scroll;
    }
  `}
`;

export const NumPerPageOptionContainer = styled.div`
  align-self: flex-start;
  position: relative;
  left: 0;
  margin: 25px 0;
  ${media.mobileTablet`
    margin: 0 16px 16px 16px;
  `}
  padding: 0px;
  display: flex;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 25px;
  min-width: 460px;
  width: 550px;
  align-item: center;
  align-centent: center;

  & p {
    font-family: ${props => props.theme.font.default};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
  }
  & input {
    margin: 0 auto;
    padding: 4px 15px 0 15px;
    height: 35px;
    width: 300px;
    border: none;
    border-left: 1px solid ${props => props.theme.color.border};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${props => props.theme.color.base2};
    background-image: none;
    &:focus {
      outline: none;
    }
  }
  & input ~ span {
    padding: 8px;
    width: 16px;
  }
  & input + ul {
    position: absolute;
    margin: 0;
    padding: 0;
    list-style-type: none;
    top: 36px;
    right: 20px;
    width: 308px;
    border: solid 1px #d6dee4;
    background-color: ${props => props.theme.color.white};
    & p {
      margin: 11px 0 0 16px;
      width: 173px;
      height: 20px;
      font-family: ${props => props.theme.font.default};
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
      color: #3f3f3f;
    }
    & p ~ li {
      text-align: -webkit-match-parent;
      width: 324px;
      height: 40px;
      padding: 12px;
      font-family: ${props => props.theme.font.default};
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      color: #4d4f54;
      &:hover {
        background-color: #f2f6f7;
        width: 100%;
        font-family: ${props => props.theme.font.bold};
      }
    }
    & svg {
      fill: ${props => props.theme.color.base2};
      margin-right: 9px;
    }
  }
`;

export const NumPerPageSelector = styled.div`
  position: relative;
  width: 68px;
  height: 32px;
  margin: 0 8px;

  & button {
    height: 35px;
    border: none;
    background-color: #f8f9f9;
    & div {
      color: #4d4f54;
    }
    & svg {
      fill: #4d4f54;
    }
    & + ul {
      font-family: ${props => props.theme.font.default};
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: solid 1px #d6dee4;
      background-color: #ffffff;
      width: 68px;
      & li {
        width: 100%;
        height: 40px;
        line-height: 16px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        color: #4d4f54;
        letter-spacing: normal;
        padding: 12px;
        &:hover {
          width: 100%;
          height: 40px;
          font-family: ${props => props.theme.font.bold};
          background-color: #f2f6f7;
        }
      }
    }
  }
`;
export const SearchResultStyleHeader = styled.div`
  font-family: ${props => props.theme.font.bold};
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: normal;
  color: ${props => props.theme.color.greyishBrown};
  ${media.mobileTablet`
    padding: 16px 16px 12px 16px;
  `}

  & > span {
    font-family: ${props => props.theme.font.default};
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.11;
    letter-spacing: normal;
  }
`;
export const Main = styled.div`
  position: relative;
  width: 100%;
  ${media.mobileTablet`
    width: 100vw;
  `}
`;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/SearchResultGrid/ResultStyle.js